<template>
	<nav class="c-nav c-timeline-nav">

		<!-- tablet allow rest point here 48px-->
		<!-- step forward by 100vw screen not year as we cannot control size of year, but possibly de-emphasise this for screenreaders as it gives them nothing-->

		<button class="c-timeline-nav__prev-main" :class="{ 'is-disabled': currentSection <= 0 }" tabindex="0" @click.prevent="prevSection">
			<span class="h-accessibility">Prev</span>
			<span class="c-timeline__icon icon i-chevron--left" role="presentation">
				<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<title>chevron-left</title>
					<path d="M21 3.5l-13.89 14L21 31.5 17.5 35 0 17.5 17.5 0z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd">
					</path>
				</svg>
			</span>
		</button>

		<button class="c-timeline-nav__prev" :class="{ 'is-disabled': currentSection <= 0 }" tabindex="0" @click.prevent="prevYear">
			<span class="h-accessibility">Prev</span>
			<span class="c-timeline__icon icon i-chevron--left" role="presentation">
				<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<title>chevron-left</title>
					<path d="M21 3.5l-13.89 14L21 31.5 17.5 35 0 17.5 17.5 0z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd">
					</path>
				</svg>
			</span>
		</button>

		<scroll-active scrollContainerSelector=".o-timeline" :clickToScroll="false" :offset="120">
			<ul class="c-timeline-nav__slider h-list">
				<li class="c-timeline-nav__item" v-for="(section, index) in sections">
					<a :href="'#'+section.id" class="c-timeline-nav__button scrollactive-item" v-text="section.getAttribute('data-sc-date')" @click.prevent="jumpToSection(section.id)" :class="{'is-active': currentSection == index  }">
					</a>
				</li>
			</ul>
		</scroll-active>

		<button class="c-timeline-nav__next" :class="{ 'is-disabled': currentSection >= sections.length }" tabindex="0" @click.prevent="nextYear">
			<span class="h-accessibility">Next</span>
			<span class="c-timeline__icon icon i-chevron--left" role="presentation">
				<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<title>chevron-right</title>
					<path d="M0 31.5l13.89-14L0 3.5 3.5 0 21 17.5 3.5 35z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd">
					</path>
				</svg>
			</span>
		</button>


		<button class="c-timeline-nav__next-main" :class="{ 'is-disabled': currentSection >= sections.length }" tabindex="0" @click.prevent="nextSection">
			<span class="h-accessibility">Next</span>
			<span class="c-timeline__icon icon i-chevron--left" role="presentation">
				<svg width="21" height="35" viewBox="0 0 21 35" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<title>chevron-right</title>
					<path d="M0 31.5l13.89-14L0 3.5 3.5 0 21 17.5 3.5 35z" fill="#000" stroke="none" stroke-width="1" fill-rule="evenodd">
					</path>
				</svg>
			</span>
		</button>

	</nav>
</template>


<script>
	import scrollActive from './scroll-active.vue';

	export default {
		name: 'timeline-nav',
		data() {
			return {
				sections: [],
				blocks: [],
				currentSection : 0,
				currentBlock : null,
			}
		},
		components: {
			scrollActive
		},
		mounted() {
			var self = this;

			// if (window.addEventListener) {
			// 		window.addEventListener("mousewheel", this.horizontalScroll, false);
			// } else {
			// 		window.attachEvent("onmousewheel", this.horizontalScroll);
			// }

			//potential race condition here
			setTimeout(function(){
				self.init();
				self.$el.classList.add('is-loaded')
			},300)
		},
		methods: {
			init() {
				this.sections = document.querySelectorAll('.js-timeline__section');

				let arr = Array.from(this.sections)

				if (this.$root.parseQueryString.year) {
					var target = document.getElementById(this.$root.parseQueryString.year);

					if (target) {
						var targetIndex = arr.findIndex(x=>x.id == this.$root.parseQueryString.year)

						this.scrollTo(document.querySelector('.o-timeline'), target.getBoundingClientRect().x, 500);

						if (targetIndex) {
							this.currentSection = targetIndex;
						}
					}
				}
			},
			detectCurrentSection() {
				console.log(this.sections[this.currentSection])
			},
			// horizontalScroll(e) {
			// 	// cross-browser wheel delta
			// 	if (e.deltaX == 0) {
			// 		e = window.event || e;
			// 		var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
			//
			// 		document.querySelector('.o-timeline').scrollBy({top:0, left:e.wheelDelta, behavior: 'auto'})
			//
			// 		e.preventDefault();
			// 	}
			// },
			//
			prevYear() {
				var slider = document.querySelector('.c-timeline-nav__slider');
				var currentStyle = document.querySelector('.c-timeline-nav__slider').style.transform.replace(/[^\d.]/g, '');
				var item = document.querySelector('.c-timeline-nav__item');

				if (currentStyle > 0) {
					slider.style.transform = 'translateX(-' + (+currentStyle - item.offsetWidth) + 'px)';
				}
			},
			nextYear() {
				var slider = document.querySelector('.c-timeline-nav__slider');
				var item = document.querySelector('.c-timeline-nav__item');
				var currentStyle = document.querySelector('.c-timeline-nav__slider').style.transform.replace(/[^\d.]/g, '');

				if (+currentStyle + window.innerWidth - 51 <= slider.offsetWidth) {
					slider.style.transform = 'translateX(-' + (+currentStyle + item.offsetWidth) + 'px)';
				}
			},
			prevSection() {
				this.scrollTo(document.querySelector('.o-timeline'),-(window.innerWidth / 100 )*60, 500);

				this.detectCurrentSection();

				// if (this.currentSection > 0) {
				//
				// 	this.currentSection --;
				//
				//
				// 	this.$root.updateQueryString('year', this.sections[this.currentSection].id)
				// 	this.scrollTo(document.querySelector('.o-timeline'), this.sections[this.currentSection].getBoundingClientRect().x, 500);
				// }
			},
			nextSection() {
				this.scrollTo(document.querySelector('.o-timeline'),(window.innerWidth / 100 )*60, 500);

				this.detectCurrentSection()

				// if (this.currentSection < this.sections.length) {
				//
				// 	this.currentSection ++;
				//
				// 	this.$root.updateQueryString('year', this.sections[this.currentSection].id)
				// 	this.scrollTo(document.querySelector('.o-timeline'), this.sections[this.currentSection].getBoundingClientRect().x, 500);
				// }
			},
			jumpToSection(id) {
				if (this.currentSection >= 0) {
					let arr = Array.from(this.sections);

					var target = document.getElementById(id);
					var targetIndex = arr.findIndex(x=>x.id == id)

					this.$root.updateQueryString('year', id)
					this.scrollTo(document.querySelector('.o-timeline'), target.getBoundingClientRect().left - 100, 500);
					this.currentSection = targetIndex;
				}
			},
			scrollTo(element, scrollPixels, duration) {
				const scrollPos = element.scrollLeft;

				if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0)))
				{
					console.log('test')
					const startTime =
						"now" in window.performance
							? performance.now()
							: new Date().getTime();

					function scroll(timestamp) {
						const timeElapsed = timestamp - startTime;
						const progress = Math.min(timeElapsed / duration, 1);
						element.scrollLeft = scrollPos + scrollPixels * progress;

						if (timeElapsed < duration) {
							window.requestAnimationFrame(scroll);
						} else {
							return;
						}
					}
					window.requestAnimationFrame(scroll);
				}
			},
			watchScroll() {

			}
		},
	};
</script>



// WEBPACK FOOTER //
// timeline-nav.vue?34b0aaec